var map = {
	"./images/background.jpg": 1492,
	"./images/button.png": 1493,
	"./images/home.png": 1494,
	"./images/percent-bg.png": 1495,
	"./images/star_1.png": 1496,
	"./images/star_2.png": 1497,
	"./images/star_3.png": 1498,
	"./images/yardnapha.png": 1499,
	"./images/yardnapha_got_1.png": 1500,
	"./images/yardnapha_got_2.png": 1501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1491;